import { CreditCardItemForm } from '@webapp/modules/accounts-payable/components/CreditCardItemForm'
import { type CreditCardAccount } from '@webapp/modules/accounts-payable/entities/CreditCardAccount'
import { type CreditCardItem } from '@webapp/modules/accounts-payable/entities/CreditCardItem'
import { useCreateCreditCardItemFormPresenter } from './useCreateCreditCardItemFormPresenter'

export interface ICreateCreditCardItemFormPresenterProps {
  /** Supplies the creditcard id + currency context for the payload */
  account: CreditCardAccount
  /** FS closes its modal; the list refreshes via invalidation (BHV-016) */
  onSuccess: (item: CreditCardItem) => void
  onCancel: () => void
}

// Form content only — the ModalDialog wrapper is FS-owned.
export const CreateCreditCardItemFormPresenter = ({
  account,
  onSuccess,
  onCancel,
}: ICreateCreditCardItemFormPresenterProps) => {
  const {
    states: { isCreating },
    methods: { onSubmit },
  } = useCreateCreditCardItemFormPresenter({ account, onSuccess })

  return (
    <CreditCardItemForm
      mode='create'
      isSaving={isCreating}
      onSubmit={onSubmit}
      onCancel={onCancel}
    />
  )
}

CreateCreditCardItemFormPresenter.displayName =
  'CreateCreditCardItemFormPresenter'
